{
	"termsAndConditions": {
		"title": "Términos y condiciones",
		"submitTitle": "Aceptar y continuar con la Política de privacidad"
	},
	"privacyPolicy": {
		"title": "Política de privacidad",
		"submitTitle": "Aceptar y cerrar",
		"backTitle": "Atrás"
	}
}
